import React from 'react'


const Cancellation = () => {
  return (
    <div>
       
       <div className="container py-lg-5 py-md-4 py-3">
  <div className="row">
    <h1 className='fw-bold'>Cancellation Policy</h1>
    <h6>Effective Date: Aug, 01, 2025</h6>
    <p>
      At TechTorch Solutions, we value our customers and aim to provide transparent policies. 
      This Cancellation Policy outlines the terms under which you may request the cancellation of services or orders.
    </p>

    <h4 className='fw-bold mt-lg-4 mt-3'>1. Service Cancellations</h4>
    <ul className="list-unstyled">
      <li>Cancellations must be requested within <span className='fw-bold'>24 hours</span> of placing the order or before the service is initiated, whichever is earlier.</li>
      <li>Once the service has commenced or digital products have been delivered, cancellations are not permitted.</li>
      <li>Custom or personalized services are strictly non-cancellable.</li>
    </ul>

    <h4 className='fw-bold mt-lg-4 mt-3'>2. How to Request a Cancellation</h4>
    <ul className="list-unstyled">
      <li>To request a cancellation, please contact us using the details below:</li>
      <li><span className='fw-bold'>Email: </span>contact@techtorch.solutions</li>
    </ul>

    <h4 className='fw-bold mt-lg-4 mt-3'>3. Changes to This Policy</h4>
    <p>
      TechTorch Solutions reserves the right to update or modify this Cancellation Policy at any time 
      without prior notice. Updates will be posted on this page, and we recommend reviewing it regularly.
    </p>
  </div>
</div>


    </div>
  )
}

export default Cancellation
